<template>
  <div class="card" v-if="loaded">
    <h3 class="bold text-primary" style="margin-bottom:6px">{{$t("Profile")}}</h3>
    <hr class="text-primary" />

    <div class="md-layout" style="margin-bottom:10px">
      <div
        class="md-layout-item md-size-15 md-large-size-20 md-medium-size-25 md-small-size-33 md-xsmall-size-90"
      >
        <img
          :src="avatarUrl"
          @error="imgNotLoaded"
          style="max-width:120px;margin-bottom:20px;margin-top:10px;border-radius: 30px;"
        />
      </div>
      <div class="md-layout-item">
        <h3 class="bold text-primary" style="margin:0px">{{model.firstName}} {{model.lastName}}</h3>

        <h6 class="text-gray regular">{{model.country}}</h6>
        <h6 class="text-gray regular" style="margin:0px 10px 0px 0px">{{model.position}}</h6>
        <h6 class="text-gray regular" style="margin:0px 10px 10px 0px">{{model.company}}</h6>
        <!-- 

        <h6 class="text-gray regular">{{model.country}}</h6>
        <h6
          class="text-gray regular"
          style="margin:0px 10px 0px 0px; font-size:14px"
        >{{model.position}}</h6>
        <h6
          class="text-gray regular"
          style="margin:0px 10px 10px 0px; font-size:14px"
        >{{model.company}}</h6>-->

        <div
          class="text-gray regular"
          style="font-size:12px; margin:0px 10px 10px 0px"
        >{{model.description}}</div>

        <h6 class="text-primary" style="margin:0px 10px 0px 0px" v-if="model.linkedIn">
          <i class="fab fa-linkedin" style="margin-right:5px"></i>
          <a :href="linkedInUrl" target="_blank" class="text-primary">{{model.linkedIn}}</a>
        </h6>
        <h6 class="text-primary" style="margin:0px 10px 0px 0px" v-if="model.twitter">
          <i class="fab fa-twitter" style="margin-right:5px"></i>
          <a :href="twitterUrl" target="_blank" class="text-primary">{{model.twitter}}</a>
        </h6>
      </div>
    </div>

    <div class="md-layout md-layout-item md-size-100" style="margin-bottom:10px">
      <div class="ml-auto">
        <md-button
          v-if="hasAttendeesAccess"
          @click.prevent="$router.push({name:'attendees'})"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:5px 10px 5px 0px"
        >{{$t('Go to attendees')}}</md-button>

        <md-button
          v-if="hasChatAccess"
          @click.prevent="$router.push({name:'chat'})"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:5px 0px 5px 0px"
        >{{$t('Go to chat')}}</md-button>
      </div>
    </div>

    <div class="md-layout">
      <div
        class="md-card md-layout-item md-size-30 md-medium-size-45 md-xsmall-size-100 text-gray regular"
        style="padding:15px; border-radius:15px;margin-bottom:10px;"
        v-if="model.hotel"
      >
        <div class="md-layout">
          <div class="md-layout-item">
            <h4 class="bold text-primary" style="margin-top:0px">Hotel</h4>
            <div style="font-size:12px">{{model.hotel}}</div>
            <div style="font-size:12px">{{model.hotelAddress}}</div>
          </div>
        </div>

        <div style="margin-top:20px">{{$t('Contact with hotel department')}}</div>
        <a class="text-primary" href="mailto:hotel@isw.org.pl">hotel@isw.org.pl</a>
      </div>
      <div v-if="model.hotel" class="md-layout-item md-size-5"></div>

      <div
        v-if="hasTransportAccess"
        class="md-card md-layout-item md-size-30 md-medium-size-45 md-xsmall-size-100 text-gray regular"
        style="padding:15px; border-radius:15px;margin-bottom:10px"
      >
        <div class="md-layout">
          <div class="md-layout-item">
            <h4 class="bold text-primary" style="margin-top:0px">Transfer</h4>
            <template v-if="model.arrival || model.departure">
                <span class="transport-status">{{$t('Transport confirmed')}}</span>
                <div style="margin-top:15px">
                    <div class="transport-label">
                        <span class="bold text-primary">{{$t('Arrival')}} </span>
                        <span class="transport-status">{{$t('at the conference')}}</span>
                    </div>
                    <div v-if="model.arrival.date" class="transport-details">
                        <md-icon>schedule</md-icon>
                        {{model.arrival.date}}
                    </div>
                    <div v-if="model.arrival.place" class="transport-details">
                        <md-icon>location_city</md-icon>
                        {{model.arrival.place}}
                    </div>
                </div>
                <div>
                    <div class="transport-label">
                        <span class="bold text-primary">{{$t('Departure')}} </span>
                        <span class="transport-status">{{$t('to the conference')}}</span>
                    </div>
                    <div v-if="model.departure.date" class="transport-details">
                        <md-icon>schedule</md-icon>
                        {{model.departure.date}}
                    </div>
                    <div v-if="model.departure.place" class="transport-details">
                        <md-icon>location_city</md-icon>
                        {{model.departure.place}}
                    </div>
                </div>          
            </template>

            <div
              v-else-if="model.signedUpForTransport"
              class="regular transport-status-container"
            >
                <span>{{$t('Request is being processed')}}</span>
                <span class="transport-status">{{$t('Wait for transport confirmation')}}</span>
            </div>
            <div v-else style="margin-top:30px">
              <router-link
                class="text-primary"
                :to="{name:'transport'}"
              >{{$t('Submit for transport')}}</router-link>
            </div>
          </div>
        </div>

        <div style="margin-top:20px">{{$t("Contact with transport department")}}</div>
        <a class="text-primary" href="mailto:transport@isw.org.pl">transport@isw.org.pl</a>
      </div>
      <div v-if="hasTransportAccess" class="md-layout-item md-size-5"></div>
      <div
        v-if="hasPartyEventAccess || model.partyEvent"
        class="md-card md-layout-item md-size-30 md-medium-size-45 md-xsmall-size-100 text-gray regular"
        style="padding:15px; border-radius:15px;margin-bottom:10px"
      >
        <div class="md-layout">
          <div class="md-layout-item">
            <h4 class="bold text-primary" style="margin-top:0px">{{$t("Recreational event")}}</h4>
            <template v-if="model.partyEvent">
              <div
                style="font-size:12px;margin-bottom:5px"
                class="text-primary bold"
              >{{model.partyEvent.title}}</div>
              <div style="font-size:12px">
                <md-icon style="margin-left:-5px">schedule</md-icon>
                {{model.partyEvent.startDate | moment('YYYY-MM-DD HH:mm')}}
              </div>
              <div style="font-size:12px" v-if="model.partyEvent.localization">
                <md-icon style="margin-left:-5px">location_city</md-icon>
                {{model.partyEvent.localization}}
              </div>

              <div style="margin-top:10px">
                <a
                  class="text-primary link"
                  @click="showPartyDetails"
                  style="margin:0px; padding:0px"
                >{{$t('Show details')}}</a>
              </div>
            </template>
          </div>
        </div>
        <div style="margin-top:20px" v-if="!model.partyEvent">
          <router-link
            class="text-primary"
            :to="{name:'party-events'}"
          >{{$t("Sign up for recreational event")}}</router-link>
        </div>
        <div style="margin-top:20px">{{$t("Contact with recreation department")}}</div>
        <a class="text-primary" href="mailto:rekreacja@isw.org.pl">rekreacja@isw.org.pl</a>
      </div>
    </div>

    <div class="modal modal-bg" :class="{ show: partyEventContent }">
      <modal v-if="partyEventContent" @close="partyEventContent = null">
        <template slot="header">
          <h3 class="title text-center">{{model.partyEvent.title}}</h3>
          <md-button
            class="md-simple md-close md-just-icon md-round modal-default-button"
            @click="partyEventContent = null"
          >
            <md-icon>clear</md-icon>
          </md-button>
        </template>

        <template slot="body">
          <div v-html="partyEventContent" />
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "@/util/axios";
import { Modal } from "@/components";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { Modal },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      hasAttendeesAccess: "user/hasAttendeesAccess",
      hasChatAccess: "user/hasChatAccess",
      hasTransportAccess: "user/hasTransportAccess",
      hasPartyEventAccess: "user/hasPartyAccess"
    }),
    avatarUrl() {
      return axios.getAttendeeAvatarUrl(
        this.conference.year,
        this.conference.type,
        this.model.externalId
      );
    },
    linkedInUrl() {
      return this.model.linkedIn;
    },
    twitterUrl() {
      return this.model.twitter;
    }
  },
  data() {
    return {
      imgLoaded: false,
      loaded: false,
      partyEventContent: null,
      model: { description: {} }
    };
  },
  methods: {
    async loadData() {
      this.model = (
        await axios.get("public/myprofile/landing", {
          params: {
            type: this.conference.type,
            year: this.conference.year,
            language: this.language.code
          }
        })
      ).data;
      this.loaded = true;
    },
    imgNotLoaded(event) {
      if (!this.imgLoaded) {
        event.target.src = require("@/assets/img/blank_avatar.png");
      }
      this.imgLoaded = true;
    },
    async showPartyDetails() {
      let result = (
        await axios.get("public/conferences/conference/party-events/details", {
          params: {
            id: this.model.partyEvent.id,
            language: this.language.code
          }
        })
      ).data;

      this.partyEventContent = result;
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async language() {
      await this.loadData();
    },
    async conference() {
      await this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.link {
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

h6 {
  text-transform: none !important;
  font-size: 0.85rem;
}

.transport-status-container {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
}

.transport-status {
    color: #454ad1;
}

.transport-label {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 5px
}

.transport-details {
    font-size: 12px;
}
</style>